import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OpreatorsMainComponent } from '../opreators-main/opreators-main.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { VillageService } from 'src/app/services/village.service';
import { RolesService } from 'src/app/services/roles.service';

@Component({
  selector: 'app-edit-opreators',
  templateUrl: './edit-opreators.component.html',
  styleUrls: ['./edit-opreators.component.css']
})
export class EditOpreatorsComponent implements OnInit {

  OpreatorForm : FormGroup | any;
  roles_list :any
  cardPermison = false;
  villages_list:any
  villages_arr:any
  rols_list:any
  roles_arr:any
  list_projects:any
  project_list:any
  savedRoles_array: any = [];
  constructor(public dialogRef: MatDialogRef<OpreatorsMainComponent>,
    private rest: VillageService,
    private rolsService: RolesService,
    @Inject(MAT_DIALOG_DATA) public data: any){}

  ngOnInit(){
    console.log(this.data)
    this.initForm()
    this.getVillages()
    this.getRoles()
    this.getProjects()
  }

  initForm() {
    this.OpreatorForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      name: new FormControl('', [Validators.required]),
      phone_number: new FormControl('', [Validators.required]),
      username: new FormControl('', [Validators.required])
    });

    this.OpreatorForm.patchValue(this.data);
    this.roles_list = this.data.role
  }

  getVillages() {
    this.rest.villageList().subscribe((res: any) => {
      console.log(res);
      this.villages_arr = res;
    });
  }


  getRoles() {
    this.rolsService.retriveOpreators().subscribe((res: any) => {
      console.log(res);
      this.roles_arr = res;
    });
  }

  getProjects() {
    this.rest.projectList().subscribe((res: any) => {
      console.log(res);
      this.project_list = res;
    });
  }

  saveCard() {
    if(this.status_radio == true){
      this.villages_list.forEach((element: any) => {
        this.savedRoles_array.push({
          roles: this.rols_list,
          village: element.name,
          villageId: element.id,
          name:"village"
        });
      });
    }else {
      this.list_projects.forEach((element: any) => {
        this.savedRoles_array.push({
          roles: this.rols_list,
          village: element.name,
          villageId: element.id,
          name:"project"
        });
      });
    }
  

    console.log(this.savedRoles_array)

    // this.cardPermison = false
    // this.roleStatus = true
  }


  status_radio = true;

  changeRadio(e: any) {
    this.status_radio = !this.status_radio;
  }

  addPermiosn(){
    this.cardPermison = true;
  }

  addOpreators(){
    let data: any = { data: this.OpreatorForm.value };
    data.data.user_id = this.data.id
    data.rolesArr = this.savedRoles_array;
    this.dialogRef.close(data);
  }
  

}
